"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var SearchThick = function SearchThick(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "SearchThick"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "search-thick"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.24 17.9l-3.5-3.52c1.145-1.445 1.836-3.294 1.836-5.304 0-4.739-3.841-8.58-8.58-8.58s-8.58 3.841-8.58 8.58c0 4.739 3.841 8.58 8.58 8.58 2.055 0 3.942-0.723 5.419-1.928l-0.016 0.012 3.5 3.5c0.173 0.169 0.409 0.272 0.67 0.272s0.497-0.104 0.67-0.273l-0 0c0.169-0.173 0.272-0.409 0.272-0.67s-0.104-0.497-0.273-0.67l0 0zM2.38 9.040c0.011-3.67 2.989-6.64 6.66-6.64 3.678 0 6.66 2.982 6.66 6.66s-2.982 6.66-6.66 6.66v0c0 0-0 0-0 0-3.678 0-6.66-2.982-6.66-6.66 0-0.007 0-0.014 0-0.021v0.001z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = SearchThick;
exports["default"] = _default;